import React, { useState, useEffect } from 'react'
import { NavLink } from "react-router-dom";
import Testimonials from './Testimonials';
import SEO from '../seo/SEO';              // Import SEO Component
import { HomeSEOData } from '../seo/HomeSEO'; // Import Home Data
import Announcements from './Announcements';
import BookSlider from './BookSlider';
import HomePageHeader from './HomePageHeader';
import { useApp } from '../AppContext';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import api from '../services';
export default function Home() {
    const [navbarOpen, setNavbarOpen] = useState(false);
    const { setBooks, books } = useApp();

    const fetchBooks = async () => {
        try {
            const booksData = await api("GET", "books");
            setBooks(booksData);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (books.length === 0) {
            fetchBooks();
        }
    }, []);
    const handleNavLinkClick = () => {
        window.scrollTo(0, 0);
        setNavbarOpen(false);
    };

    return (
        <>
            <SEO {...HomeSEOData} />
            <HomePageHeader />

            <main>
                <BookSlider books={books} />
                <Announcements />
                <Testimonials />
                <section className="py-5">
                    <div className="container px-5 my-5">
                        <div className="row gx-5 justify-content-center">
                            <div className="col-lg-12 col-xl-12">
                                <div className="text-center">
                                    <h2 className="fw-bolder">നിങ്ങളുടെ പുസ്തകം ഞങ്ങളിലൂടെ പ്രസിദ്ധീകരിക്കൂ</h2>
                                    <p className="lead fs-6 fw-normal text-muted mb-5">
                                        പുതിയ എഴുത്തുകാരെയും പുതുമയുള്ള കൃതികളെയും തെരഞ്ഞെടുത്ത് പ്രസിദ്ധീകരിക്കുകയും അത് പരമാവധി വായനക്കാരിലെത്തിക്കുകയും ചെയ്യുക.പ്രത്യേകിച്ച് വൈജ്ഞാനികം, ബാലസാഹിത്യം, ചരിത്രം, നിരൂപണം എന്നിവയ്ക്ക് പ്രാധാന്യം.  കൈയെഴുത്തുപ്രതിയിൽ നിന്ന് പ്രസിദ്ധീകരണം വരെ — എഡിറ്റിംഗ്, ഡിസൈൻ, ISBN, പ്രിന്റിംഗ്, മാർക്കറ്റിംഗ്, വിൽപ്പന എന്നിവ എല്ലാം ഞങ്ങൾ കൈകാര്യം ചെയ്യുന്നു. നിങ്ങളുടെ രചനയെ ഒരു മനോഹര പുസ്തകമായി മാറ്റാൻ ഇന്ന് തന്നെ ഞങ്ങളെ ബന്ധപ്പെടൂ.
                                    </p>
                                    <NavLink
                                        className="btn btn-outline btn-primary btn-lg px-4"
                                        to="/become-publisher"
                                        onClick={handleNavLinkClick}
                                    >
                                        Learn More
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <section className="py-5 bg-light-green">
                    <div className='container'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-8 col-xl-8 text-center'>
                                <iframe
                                    width="100%"
                                    height="400"
                                    src="https://www.youtube.com/embed/f78S6qdecQ4?autoplay=1&mute=1"
                                    title="Uyirmozhy Introduction Video"
                                    frameBorder="0"
                                    loading="lazy"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </section> */}
            </main>
        </>
    )
}